import React, { Component } from "react";
import { connect } from "react-redux";
import * as Actions from "../store/actions/index";
import cx from "classnames";
import device from "current-device";
import Animate from "react-move/Animate";
import { easeExpOut, easeLinear, easeSinOut } from "d3-ease";
import Grid from "material-ui/Grid";
import Tabs, { Tab } from "material-ui/Tabs";
import { CircularProgress } from "material-ui/Progress";
import Modal from "material-ui/Modal";
import Snackbar, { SnackbarContent } from "material-ui/Snackbar";
import IconButton from "material-ui/IconButton";
import Welcome from "../components/static/Welcome";
import NoSampleMessage from "../components/static/NoSampleMessage";
import MobileMenu from "../components/static/MobileMenu";
import SearchBox from "../components/SearchBox";
import Results from "../components/Results/";
import Logo from "../components/graphics/Logo";
import Icon from "../components/graphics/Icon";
import Detail from "../components/Detail";
import Help from "../components/static/Help";
import FAQ from "../components/FAQ";
import FooterLinks from "../components/static/FooterLinks";
import Footer from "../components/static/Footer";
import "../assets/css/fontello.css";
import "./Layout.css";
import GoogleMap from "../components/GoogleMap";
import "simplebar";
import "simplebar/dist/simplebar.css";
import $ from "jquery";
import ios from "../assets/appledownload.png";
import android from "../assets/googledownload.png";
import {
  App,
  DownloadMessage,
  Map,
  SearchResults,
  LogoWrapper,
  MobileButton,
  TabContainer,
  TabContent,
  TabArea,
  Header,
  Search,
  InfoBtn,
  Loader
} from "./style.js";

const tabStyle = {
  minWidth: 0
};

class Layout extends Component {
  constructor(props) {
    super(props);
    this.onResize = this.onResize.bind(this);
    this.state = {
      showHelp: false,
      showFAQ: false,
      showMobileMenu: false,
      showExpandedAlert: false,
      globalAlertText: "Dude, where's my grade?",
      fullScreenHeight: 0,
      NSMessageExpanded: false,
      initLat: 0,
      mobileMessage: true
    };
  }
  componentWillMount() {
    const { router, changeMap, onSetDetail } = this.props;
    var path = router.pathname.split("/");
    if (path.length > 2) {
      changeMap({
        center: {
          lat: parseFloat(path[1]),
          lng: parseFloat(path[2])
        },
        zoom: parseInt(path[3])
      });
      this.setState({ initLat: parseFloat(path[1]) });
    }
    if (path.length > 4) {
      onSetDetail(path[4]);
    }
  }
  componentDidMount() {
    const { router, resultsShown, fetchLocations, onFetchAds, onFetchNews } =
      this.props;
    var _this = this;
    var path = router.pathname.split("/");
    fetchLocations();
    onFetchNews();
    onFetchAds();
    this.setState({ fullScreenHeight: document.documentElement.clientHeight });
    window.addEventListener("orientationchange", function () {
      if (resultsShown) window.location.reload();
    });
  }
  componentDidUpdate() {
    if (this.props.selectedItem) {
      if (device.mobile()) {
        window.scrollTo(0, document.body.scrollHeight);
      }
    }
    window.addEventListener("resize", this.onResize, false);
  }
  componentWillReceiveProps() {}
  fetchData = (south, north) => {
    const url = process.env.REACT_APP_BRC_API_URL + "/locations";

    return $.post(url, {
      query: {
        range: {
          northSouthOrder: {
            gte: south, //South
            lte: north //North
          }
        }
      }
    });
  };
  onResize() {
    this.props.onSetWindowSize({
      wW: document.documentElement.clientWidth,
      wH: document.documentElement.clientHeight
    });
    this.setState({ fullScreenHeight: document.documentElement.clientHeight });
  }
  renderWelcome() {
    const { resultsShown, wW, wH } = this.props;
    const isMobile = device.mobile();

    if (isMobile) {
      window.scrollTo(0, 0);
    }

    const show = isMobile ? !resultsShown : true;

    return (
      <Animate
        show={show}
        start={() => ({
          y: 0,
          o: 1
        })}
        leave={() => ({
          y: [resultsShown && wH > wW ? "100%" : "0px"],
          o: [resultsShown && wH > wW ? "none" : "block"],
          timing: { duration: 700, ease: easeSinOut }
        })}>
        {(state) => {
          const { y, o } = state;
          return (
            <Welcome
              pos={y}
              show={o}
              ismobile={device.mobile() ? "true" : undefined}
            />
          );
        }}
      </Animate>
    );
  }
  handleTabChange = (event, tab) => {
    const {
      activeTab,
      changeTab,
      onShowInfo,
      onSetResults,
      onShowResults,
      sort,
      sortResults
    } = this.props;
    onShowResults(true);
    if (tab !== activeTab) {
      changeTab(tab);
      onShowInfo(false);
      onSetResults();
    } else {
      switch (sort) {
        case "default":
          onSetResults("best");
          sortResults("best");
          break;
        case "best":
          onSetResults("worst");
          sortResults("worst");
          break;
        case "worst":
          onSetResults("default");
          sortResults("default");
          break;
      }
    }
  };
  handleCloseMobileDownload = () => {
    console.log("handleCloseMobileDownload");
    this.setState({ mobileMessage: false });
  };
  handleToggleNSMessage = () => {
    this.setState({ NSMessageExpanded: !this.state.NSMessageExpanded });
  };
  handleCloseNSMessage = (event) => {
    this.props.showGlobalAlert(false);
    this.props.onUserClosedNSMessage(true);
  };
  renderTabs() {
    const { activeTab, resultsShown, sort } = this.props;
    return (
      <Animate
        start={() => ({
          o: 0
        })}
        enter={() => ({
          o: 1,
          timing: { duration: 1750, ease: easeExpOut }
        })}
        leave={() => ({
          o: 0,
          timing: { duration: 1750, ease: easeExpOut }
        })}>
        {(state) => {
          const { o } = state;
          return (
            <TabArea className={resultsShown ? "with-tabs" : ""}>
              <TabContainer
                style={{
                  opacity: `${o}`
                }}>
                <Tabs
                  value={activeTab}
                  onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  centered>
                  <Tab
                    style={tabStyle}
                    classes={{ selected: "active" }}
                    label="All"
                    icon={
                      sort === "default" ? (
                        <Icon name="sort" />
                      ) : sort === "best" ? (
                        <Icon name="best" />
                      ) : (
                        <Icon name="worst" />
                      )
                    }>
                    All
                  </Tab>
                  <Tab
                    style={tabStyle}
                    classes={{ selected: "active" }}
                    label="NowCast"
                    icon={
                      sort === "default" ? (
                        <Icon name="sort" />
                      ) : sort === "best" ? (
                        <Icon name="best" />
                      ) : (
                        <Icon name="worst" />
                      )
                    }>
                    NowCast
                  </Tab>
                  <Tab
                    style={tabStyle}
                    classes={{ selected: "active" }}
                    label="Grades"
                    icon={
                      sort === "default" ? (
                        <Icon name="sort" />
                      ) : sort === "best" ? (
                        <Icon name="best" />
                      ) : (
                        <Icon name="worst" />
                      )
                    }>
                    Grades
                  </Tab>
                  <Tab
                    style={tabStyle}
                    classes={{ selected: "active" }}
                    label="Alerts">
                    Alerts
                  </Tab>
                </Tabs>
              </TabContainer>
            </TabArea>
          );
        }}
      </Animate>
    );
  }
  renderTabContent() {
    const { activeTab, resultsShown, slideSelected, wW, wH } = this.props;
    if (resultsShown) {
      if (wH > wW) {
        return (
          <TabContent className="tabContent">
            <Results tab={activeTab} />
          </TabContent>
        );
      }
      return (
        <TabContent className="tabContent" data-simplebar>
          <Results tab={activeTab} goTo={slideSelected} />
          <FooterLinks />
        </TabContent>
      );
    } else {
      return null;
    }
  }
  renderDetail() {
    const { detailShown } = this.props;
    return (
      <Animate
        show={detailShown}
        start={{
          o: 0
        }}
        enter={() => ({
          o: 1,
          timing: { duration: 750, ease: easeLinear }
        })}
        leave={() => ({
          o: 0,
          timing: { duration: 350, ease: easeLinear }
        })}>
        {(state) => {
          const { o } = state;
          return (
            <Detail
              style={{
                opacity: `${o}`
              }}
            />
          );
        }}
      </Animate>
    );
  }
  renderLoader() {
    if (this.props.locations.length === 0) {
      return (
        <Loader>
          <CircularProgress size={80} color="secondary" />
        </Loader>
      );
    }
  }
  toggleHelp = () => {
    this.setState({ showHelp: !this.state.showHelp });
  };
  renderHelp() {
    const { showHelp } = this.state;
    return (
      <Animate
        show={showHelp}
        start={() => ({
          o: 0
        })}
        enter={() => ({
          o: 1
        })}
        leave={() => ({
          o: 0
        })}>
        {(state) => {
          const { o } = state;
          return (
            <Help
              opacity={o}
              closeHelp={() => this.toggleHelp()}
              openFAQ={() => this.toggleFAQ()}
            />
          );
        }}
      </Animate>
    );
  }
  toggleMobileMenu = () => {
    this.setState({ showMobileMenu: !this.state.showMobileMenu });
  };
  renderMobileMenu() {
    const { results, news } = this.props;
    const { showMobileMenu } = this.state;
    return (
      <Animate
        show={showMobileMenu}
        start={() => ({
          o: 0
        })}
        enter={() => ({
          o: 1
        })}
        leave={() => ({
          o: 0
        })}>
        {(state) => {
          const { o } = state;
          return (
            <MobileMenu
              opacity={o}
              onClose={() => this.toggleMobileMenu()}
              showHelp={() => this.toggleHelp()}
              results={results}
              news={news}
            />
          );
        }}
      </Animate>
    );
  }
  returnMapToInit = () => {
    this.props.onChangeMap({
      center: { lat: 33.9103, lng: -118.519291 },
      zoom: 11
    });
  };
  toggleFAQ = () => {
    this.setState({ showFAQ: !this.state.showFAQ });
  };
  renderFAQ() {
    if (this.state.showFAQ) {
      return (
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.showFAQ}>
          <FAQ onClose={() => this.toggleFAQ()} />
        </Modal>
      );
    }
  }
  renderFooter() {
    if (document.documentElement.clientWidth >= 960) {
      return <Footer />;
    }
  }
  renderMobileDownload = () => {
    if (device.mobile() || device.tablet()) {
      return (
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          open={this.state.mobileMessage}
          onClose={this.handleCloseMobileDownload}>
          <SnackbarContent
            aria-describedby="client-snackbar"
            style={{ alignItems: "flex-start" }}
            message={
              <DownloadMessage>
                <p>
                  For the best experience, download the Beach Report Card app.
                </p>
                <a
                  href="https://itunes.apple.com/us/app/beach-report-card/id472446703"
                  target="_blank">
                  <img src={ios} alt="iOS app" width="150" />
                </a>{" "}
                &nbsp;
                <a
                  href="https://play.google.com/store/apps/details?id=org.healthebay.brc"
                  target="_blank">
                  <img src={android} alt="Android app" width="150" />
                </a>
              </DownloadMessage>
            }
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleCloseMobileDownload}>
                <Icon name="closeWhite" />
              </IconButton>
            ]}
          />
        </Snackbar>
      );
    } else {
      return null;
    }
  };
  render() {
    const {
      locations,
      resultsShown,
      searchIsOpen,
      hasSearched,
      mapFullHeight,
      map,
      globalAlertShown,
      userClosed,
      wW,
      wH
    } = this.props;
    const { showMobileMenu, fullScreenHeight, NSMessageExpanded } = this.state;
    var showNSMessage = resultsShown;
    if (device.desktop()) showNSMessage = true;
    var mobileHeight = fullScreenHeight + "px";
    var mobileKeyboardTranslate = fullScreenHeight - wH + "px";
    // console.log('hasSearched: ', hasSearched);
    return (
      <App
        className={cx({
          init: !resultsShown,
          searching: searchIsOpen,
          desktop: device.desktop()
        })}
        wh={mobileHeight}>
        {this.renderMobileDownload()}
        <NoSampleMessage
          show={globalAlertShown && !userClosed && showNSMessage}
          expanded={NSMessageExpanded}
          toggleMessage={this.handleToggleNSMessage}
          closeMessage={this.handleCloseNSMessage}
        />
        <MobileButton
          className={showMobileMenu ? "open" : ""}
          onClick={this.toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </MobileButton>
        <LogoWrapper>
          <Logo logo="brc" handleOnClick={this.returnMapToInit} />
        </LogoWrapper>
        {this.renderDetail()}
        {this.renderMobileMenu()}
        {this.renderFAQ()}
        {this.renderHelp()}
        {this.renderWelcome()}
        <Map
          id="map"
          className={cx({
            full: mapFullHeight || searchIsOpen,
            init: !resultsShown
          })}
          wh={mobileHeight}
          searchheight={hasSearched ? "100px" : "70px"}>
          {this.renderLoader()}
          <GoogleMap />
        </Map>
        <SearchResults
          id="results"
          className={cx({
            shrink: mapFullHeight || searchIsOpen,
            init: !resultsShown,
            isOpen: searchIsOpen && !resultsShown,
            device: device.mobile() || device.tablet()
          })}
          wh={mobileHeight}
          keyboardTranslate={mobileKeyboardTranslate}>
          <Header className="header">
            <Search>
              <SearchBox />
              <InfoBtn onClick={this.toggleHelp}>?</InfoBtn>
            </Search>
          </Header>
          {this.renderTabs()}
          {this.renderTabContent()}
        </SearchResults>
        {this.renderFooter()}
      </App>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locations: state.brc.locations,
    activeTab: state.brc.activeTab,
    sort: state.brc.sort,
    selectedItem: state.brc.selectedItem,
    mapOptions: state.brc.mapOptions,
    resultsShown: state.brc.resultsShown,
    detailShown: state.brc.detailShown,
    detail: state.brc.detail,
    clusters: state.brc.clusters,
    showHelp: state.brc.showHelp,
    results: state.brc.results,
    news: state.brc.news,
    wW: state.brc.wW,
    wH: state.brc.wH,
    hoverId: state.brc.hoverId,
    searchIsOpen: state.brc.searchIsOpen,
    slideSelected: state.brc.slideSelected,
    mapFullHeight: state.brc.mapFullHeight,
    globalAlertShown: state.brc.globalAlertShown,
    userClosed: state.brc.userClosed,
    map: state.brc.map,
    hasSearched: state.brc.hasSearched,
    router: state.router
  };
};

export default connect(mapStateToProps, { ...Actions })(Layout);



// WEBPACK FOOTER //
// ./src/containers/Layout.js